import { CandidateMatchComponentTypeDto } from '@/api/generated';
import { ComponentsTranslation } from '@/assets/locales/components/components.translation.en.ts';
import { confirmDialogTranslation } from '@/assets/locales/components/confirmDialog/confirmDialog.translation.pl.ts';
import { fallbackUiTranslation } from '@/assets/locales/components/falbackUi/fallbackUi.translation.pl.ts';
import { componentsFormTranslation } from '@/assets/locales/components/form/components.form.translation.pl.ts';
import { infoDialogTranslation } from '@/assets/locales/components/infoDialog/infoDialog.translation.pl.ts';
import { tableTranslations } from '@/assets/locales/components/table/table.translations.pl.ts';
import { versionCheckerTranslations } from '@/assets/locales/components/versionChecker/versionChecker.translations.pl.ts';

export const componentsTranslation: ComponentsTranslation = {
  aiGenerated: {
    tooltip: 'Treść wygenerowana przez AI',
  },
  confirmDialog: confirmDialogTranslation,
  fallbackUi: fallbackUiTranslation,
  form: componentsFormTranslation,
  infoDialog: infoDialogTranslation,
  match: 'Dopasowanie',
  matchScore: {
    componentMatch: {
      [CandidateMatchComponentTypeDto.CompanyLoyalty]: 'Lojalność',
      [CandidateMatchComponentTypeDto.IndustryExperience]: 'Preferowana branża',
      [CandidateMatchComponentTypeDto.MainAnalysis]: 'Główna analiza',
    },
    legendTitle: 'Składowe wyniku',
  },
  table: tableTranslations,
  versionChecker: versionCheckerTranslations,
};
